import { render, staticRenderFns } from "./base-treeselect.vue?vue&type=template&id=08ddd731"
import script from "./base-treeselect.vue?vue&type=script&lang=js"
export * from "./base-treeselect.vue?vue&type=script&lang=js"
import style0 from "./base-treeselect.vue?vue&type=style&index=0&id=08ddd731&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports